import type { CashReport, CashTicket } from './types';
import { t } from '../lib/i18n';

const DAEMON_TIMEOUT_MS = 30_000;

async function fetchJSON<T>(url: string, opts: { timeoutMs?: number; daemon?: boolean } = {}): Promise<T> {
  const ctl = new AbortController();
  const timer = setTimeout(() => ctl.abort(), opts.timeoutMs ?? 8_000);
  try {
    const res = await fetch(url, { credentials: 'same-origin', signal: ctl.signal });
    if (!res.ok) {
      if (opts.daemon && (res.status === 502 || res.status === 503)) {
        throw new Error(t.errors.daemonOffline);
      }
      if (res.status === 503) throw new Error('cache not ready');
      throw new Error(`HTTP ${res.status}`);
    }
    return (await res.json()) as T;
  } finally {
    clearTimeout(timer);
  }
}

export function fetchCashReport(args: {
  from: string;
  to: string;
  sid?: number;
}): Promise<CashReport> {
  const q = new URLSearchParams({ from: args.from, to: args.to });
  if (args.sid !== undefined) q.set('sid', String(args.sid));
  return fetchJSON<CashReport>(`/api/cash-report?${q}`, { timeoutMs: DAEMON_TIMEOUT_MS, daemon: true });
}

export function fetchCashTickets(args: {
  from: string;
  to: string;
  sid?: number;
  date?: string;
  tender?: string;
  cashier?: string;
}): Promise<CashTicket[]> {
  const q = new URLSearchParams({ from: args.from, to: args.to });
  if (args.sid !== undefined) q.set('sid', String(args.sid));
  if (args.date !== undefined) q.set('date', args.date);
  if (args.tender !== undefined) q.set('tender', args.tender);
  if (args.cashier !== undefined) q.set('cashier', args.cashier);
  return fetchJSON<CashTicket[]>(`/api/cash-tickets?${q}`, { timeoutMs: DAEMON_TIMEOUT_MS, daemon: true });
}
